module.exports = __webpack_public_path__ + "media/images/niq-edit-fill-8d65c494884ae0699dc71cfe100d37e9.svg";